<template>
  <div
    class="div"
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <h1 class="h1">【{{ updates.title }}】</h1>
    <a-button class="button" type="primary" @click="update">更新</a-button>

    <a-row>
      <span>内容</span>
    </a-row>
    <a-divider />
    <a-row class="icon">
      <a-icon type="snippets" />
      <a-icon type="font-colors" />
      <a-icon type="bold" />
      <a-icon type="italic" />
    </a-row>
    <a-row> 隐私协议： </a-row>
    <a-row class="content">
      <!-- <a-textarea
        v-model="updates.content"
        placeholder="Basic usage"
        :rows="4"
      /> -->
      <quill-editor
        v-model="updates.content"
        ref="myQuillEditor"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @change="onEditorChange($event)"
      >
      </quill-editor>
    </a-row>
  </div>
</template>

<script>
import { userDetails, updateuserDetails } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
export default {
  name: "ProtocolRulesTwo",
  data() {
    return {
      updates: {
        objId: "",
        title: "隐私协议",
        content: "",
        type: 1301,
      },
    };
  },
  mounted() {
    this.getUserDetails();
  },
  methods: {
    getUserDetails() {
      userDetails(1301).then((res) => {
        this.updates.title = res.data.title;
        this.updates.content = res.data.content;
        this.updates.objId = res.data.objId;
      });
    },
    update() {
      updateuserDetails(this.updates).then((res) => {
        this.getUserDetails();
        message.success("更新成功");
      });
    },
  },
};
</script>

<style scoped>
.div {
  height: 80vh;
}
.content {
  margin-top: 20px;
  margin-left: 20px;
}
.button {
  position: relative;
  left: 500px;
  bottom: 50px;
  width: 100px;
  height: 40px;
}
.h1 {
  font-size: 28px;
}
.icon {
  height: 50px;
}
.icon a-icon {
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProtocolRulesTwo.vue